// Botanical SVGs — olive sprig, lavender stem, cascading wisteria vine

window.OliveSprig = ({ style = {}, stroke = 'currentColor', className = '' }) => (
  <svg viewBox="0 0 120 240" fill="none" stroke={stroke} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" style={style} className={className} aria-hidden="true">
    <path d="M60 10 C58 60, 58 140, 60 230" />
    <g>
      <ellipse cx="44" cy="40" rx="18" ry="7" transform="rotate(-30 44 40)" fill={stroke} fillOpacity="0.12"/>
      <ellipse cx="44" cy="40" rx="18" ry="7" transform="rotate(-30 44 40)" />
    </g>
    <g>
      <ellipse cx="76" cy="62" rx="18" ry="7" transform="rotate(28 76 62)" fill={stroke} fillOpacity="0.12"/>
      <ellipse cx="76" cy="62" rx="18" ry="7" transform="rotate(28 76 62)" />
    </g>
    <g>
      <ellipse cx="40" cy="92" rx="20" ry="8" transform="rotate(-25 40 92)" fill={stroke} fillOpacity="0.12"/>
      <ellipse cx="40" cy="92" rx="20" ry="8" transform="rotate(-25 40 92)" />
    </g>
    <g>
      <ellipse cx="80" cy="120" rx="20" ry="8" transform="rotate(30 80 120)" fill={stroke} fillOpacity="0.12"/>
      <ellipse cx="80" cy="120" rx="20" ry="8" transform="rotate(30 80 120)" />
    </g>
    <g>
      <ellipse cx="40" cy="150" rx="19" ry="7.5" transform="rotate(-28 40 150)" fill={stroke} fillOpacity="0.12"/>
      <ellipse cx="40" cy="150" rx="19" ry="7.5" transform="rotate(-28 40 150)" />
    </g>
    <g>
      <ellipse cx="78" cy="178" rx="18" ry="7" transform="rotate(26 78 178)" fill={stroke} fillOpacity="0.12"/>
      <ellipse cx="78" cy="178" rx="18" ry="7" transform="rotate(26 78 178)" />
    </g>
    <g>
      <ellipse cx="44" cy="206" rx="16" ry="6.5" transform="rotate(-26 44 206)" fill={stroke} fillOpacity="0.12"/>
      <ellipse cx="44" cy="206" rx="16" ry="6.5" transform="rotate(-26 44 206)" />
    </g>
    <ellipse cx="66" cy="78" rx="3.5" ry="5" fill={stroke} fillOpacity="0.35"/>
    <ellipse cx="54" cy="132" rx="3.5" ry="5" fill={stroke} fillOpacity="0.35"/>
    <ellipse cx="66" cy="164" rx="3.5" ry="5" fill={stroke} fillOpacity="0.35"/>
  </svg>
);

window.LavenderStem = ({ style = {}, stroke = 'currentColor', accent = 'currentColor', className = '' }) => (
  <svg viewBox="0 0 80 240" fill="none" stroke={stroke} strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" style={style} className={className} aria-hidden="true">
    <path d="M40 238 C40 200, 40 140, 40 90" />
    <path d="M40 200 C30 190, 22 178, 18 160" />
    <path d="M40 200 C50 190, 58 178, 62 160" />
    <path d="M40 180 C32 172, 26 160, 24 144" />
    <path d="M40 180 C48 172, 54 160, 56 144" />
    <g fill={accent} fillOpacity="0.55" stroke="none">
      <ellipse cx="40" cy="20" rx="5" ry="6"/>
      <ellipse cx="34" cy="30" rx="5" ry="6"/>
      <ellipse cx="46" cy="30" rx="5" ry="6"/>
      <ellipse cx="38" cy="40" rx="5" ry="6"/>
      <ellipse cx="44" cy="40" rx="5" ry="6"/>
      <ellipse cx="34" cy="50" rx="5" ry="6"/>
      <ellipse cx="46" cy="50" rx="5" ry="6"/>
      <ellipse cx="40" cy="60" rx="5" ry="6"/>
      <ellipse cx="35" cy="70" rx="4.5" ry="5.5"/>
      <ellipse cx="45" cy="70" rx="4.5" ry="5.5"/>
      <ellipse cx="40" cy="80" rx="4" ry="5"/>
    </g>
    <g>
      <ellipse cx="40" cy="20" rx="5" ry="6"/>
      <ellipse cx="34" cy="30" rx="5" ry="6"/>
      <ellipse cx="46" cy="30" rx="5" ry="6"/>
      <ellipse cx="38" cy="40" rx="5" ry="6"/>
      <ellipse cx="44" cy="40" rx="5" ry="6"/>
      <ellipse cx="34" cy="50" rx="5" ry="6"/>
      <ellipse cx="46" cy="50" rx="5" ry="6"/>
      <ellipse cx="40" cy="60" rx="5" ry="6"/>
    </g>
  </svg>
);

/* ---- Cascading wisteria (glycine) vine ---- */
// Lush, romantic pendant: densely overlapping petals in a tapering teardrop
window.WisteriaCluster = ({ stroke = 'currentColor', accent = 'currentColor', accentDeep, seed = 0 }) => {
  const deep = accentDeep || accent;
  const s = seed;
  // Seeded pseudo-random for stable layout
  let r = 1 + s * 13.37;
  const rnd = () => { r = (r * 9301 + 49297) % 233280; return r / 233280; };

  // Build a teardrop envelope: widest ~25% from top, tapering to point
  const H = 200;
  const petals = [];
  const N = 120; // dense cluster
  for (let i = 0; i < N; i++) {
    const t = i / (N - 1);
    // width envelope — wide at top third, narrow at tip
    const env = Math.pow(Math.sin(Math.min(1, (t + 0.04) * 1.02) * Math.PI), 0.7);
    const maxW = 16 * env + 1.5;
    // random position within envelope
    const ox = (rnd() * 2 - 1) * maxW;
    const oy = t * H + (rnd() - 0.5) * 4;
    // vine sway
    const sway = Math.sin(t * 2.2 + s * 1.4) * 4 * (1 - t * 0.4);
    // petal size — smaller at bottom, larger at top-mid
    const size = 2.2 + (1 - Math.abs(t - 0.25)) * 1.6 + rnd() * 0.6;
    // color: mix deep / accent / soft for painterly feel
    const roll = rnd();
    const fill = roll < 0.25 ? deep : (roll < 0.85 ? accent : deep);
    const op = 0.45 + rnd() * 0.4;
    petals.push({ cx: ox + sway, cy: oy + 10, r: size, fill, op, rot: rnd() * 360 });
  }

  return (
    <g>
      {/* drooping stem */}
      <path
        d={`M0 0 C ${-3 + s*1.3} 50, ${3 + s*0.8} 110, ${s*0.4} 170 S ${s*0.2} 198, ${s*0.2} 210`}
        fill="none"
        stroke={stroke}
        strokeOpacity="0.45"
        strokeWidth="0.9"
        strokeLinecap="round"
      />
      {/* two starter leaves */}
      <ellipse cx={-5 + s} cy={6} rx="7" ry="2.4" transform={`rotate(-28 ${-5 + s} 6)`} fill={stroke} fillOpacity="0.3" stroke={stroke} strokeOpacity="0.5" strokeWidth="0.4"/>
      <ellipse cx={6 + s} cy={10} rx="7" ry="2.4" transform={`rotate(28 ${6 + s} 10)`} fill={stroke} fillOpacity="0.3" stroke={stroke} strokeOpacity="0.5" strokeWidth="0.4"/>

      {/* shadow base — soft lilac wash */}
      {petals.filter((_, i) => i % 3 === 0).map((p, i) => (
        <ellipse key={`s${i}`} cx={p.cx} cy={p.cy} rx={p.r * 1.6} ry={p.r * 1.8} fill={accent} fillOpacity="0.15"/>
      ))}
      {/* petals */}
      {petals.map((p, i) => (
        <ellipse
          key={i}
          cx={p.cx}
          cy={p.cy}
          rx={p.r * 0.85}
          ry={p.r}
          fill={p.fill}
          fillOpacity={p.op}
          transform={`rotate(${p.rot} ${p.cx} ${p.cy})`}
        />
      ))}
      {/* deeper accents at the top of each cluster for dimension */}
      {petals.filter((_, i) => i < 25).map((p, i) => (
        <circle key={`d${i}`} cx={p.cx} cy={p.cy} r="0.6" fill={deep} fillOpacity="0.75"/>
      ))}
    </g>
  );
};

// Canopy of glycine cascading from the top edge
window.WisteriaCanopy = ({ stroke = 'currentColor', accent = 'currentColor', accentDeep, className = '', style = {} }) => {
  const clusters = [
    { x: 4,  y: 3,  scale: 0.9,  seed: 0.3 },
    { x: 15, y: 6,  scale: 1.2,  seed: -0.5 },
    { x: 26, y: 2,  scale: 0.75, seed: 0.8 },
    { x: 37, y: 5,  scale: 1.05, seed: -0.2 },
    { x: 49, y: 2,  scale: 0.7,  seed: 0.4 },
    { x: 61, y: 6,  scale: 1.1,  seed: -0.7 },
    { x: 72, y: 2,  scale: 0.85, seed: 0.6 },
    { x: 83, y: 5,  scale: 1.15, seed: -0.4 },
    { x: 94, y: 3,  scale: 0.8,  seed: 0.2 },
  ];
  return (
    <svg
      viewBox="0 0 100 60"
      preserveAspectRatio="xMidYMin slice"
      className={className}
      style={style}
      aria-hidden="true"
    >
      <path d="M-2 2 Q 25 5 50 3 T 102 4" fill="none" stroke={stroke} strokeOpacity="0.4" strokeWidth="0.25"/>
      {[8, 22, 34, 48, 58, 72, 88].map((x, i) => (
        <ellipse key={i} cx={x} cy={2 + (i%2)*0.6} rx="2" ry="0.7" transform={`rotate(${i%2 ? -20 : 20} ${x} ${2 + (i%2)*0.6})`} fill={stroke} fillOpacity="0.3"/>
      ))}
      {clusters.map((c, i) => (
        <g key={i} transform={`translate(${c.x} ${c.y})`}>
          <g transform={`scale(${0.14 * c.scale})`}>
            <WisteriaCluster stroke={stroke} accent={accent} accentDeep={accentDeep} seed={c.seed} />
          </g>
        </g>
      ))}
    </svg>
  );
};

/* ---- Ornamental corner flourishes ---- */
window.CornerFlourish = ({ stroke = 'currentColor', accent = 'currentColor', flip = false, className = '' }) => (
  <svg viewBox="0 0 120 120" className={className} fill="none" stroke={stroke} strokeWidth="0.8" strokeLinecap="round" aria-hidden="true"
    style={flip ? { transform: 'scaleX(-1)' } : {}}>
    {/* main curve */}
    <path d="M8 112 C 8 70, 30 40, 70 28" />
    {/* secondary vine */}
    <path d="M16 112 C 20 88, 34 64, 58 50" strokeOpacity="0.55"/>
    {/* small leaves */}
    <ellipse cx="28" cy="78" rx="7" ry="3" transform="rotate(-40 28 78)" fill={stroke} fillOpacity="0.18"/>
    <ellipse cx="44" cy="58" rx="7" ry="3" transform="rotate(-30 44 58)" fill={stroke} fillOpacity="0.18"/>
    <ellipse cx="62" cy="42" rx="8" ry="3.5" transform="rotate(-20 62 42)" fill={stroke} fillOpacity="0.18"/>
    {/* tiny blossoms */}
    <circle cx="38" cy="68" r="2.2" fill={accent} fillOpacity="0.7"/>
    <circle cx="52" cy="52" r="2.2" fill={accent} fillOpacity="0.7"/>
    <circle cx="72" cy="34" r="2.5" fill={accent} fillOpacity="0.8"/>
    <circle cx="80" cy="24" r="1.6" fill={accent} fillOpacity="0.6"/>
  </svg>
);

window.Monogram = ({ size = 120, color = 'currentColor' }) => (
  <svg viewBox="0 0 120 120" width={size} height={size} fill="none" stroke={color} strokeWidth="0.8" aria-hidden="true">
    <circle cx="60" cy="60" r="56" strokeDasharray="2 3"/>
    <text x="60" y="58" textAnchor="middle" fontFamily="'Cormorant Garamond', serif" fontSize="38" fontStyle="italic" fill={color} stroke="none">N</text>
    <text x="60" y="58" textAnchor="middle" fontFamily="'Cormorant Garamond', serif" fontSize="38" fontStyle="italic" fill={color} stroke="none" dx="14">F</text>
    <text x="60" y="58" textAnchor="middle" fontFamily="'Cormorant Garamond', serif" fontSize="38" fontStyle="italic" fill={color} stroke="none" dx="-14">&amp;</text>
    <text x="60" y="90" textAnchor="middle" fontFamily="'Inter', sans-serif" fontSize="7" letterSpacing="3" fill={color} stroke="none">10 · IV · MMXXVII</text>
  </svg>
);

window.Divider = ({ color = 'currentColor', accent }) => (
  <svg viewBox="0 0 280 24" width="280" height="24" fill="none" stroke={color} strokeWidth="1" strokeLinecap="round" aria-hidden="true">
    <line x1="10" y1="12" x2="110" y2="12"/>
    <line x1="170" y1="12" x2="270" y2="12"/>
    {/* ornament cluster in middle */}
    <circle cx="140" cy="12" r="3.5" fill={accent || color} stroke="none"/>
    <circle cx="124" cy="12" r="1.5" fill={color} stroke="none"/>
    <circle cx="156" cy="12" r="1.5" fill={color} stroke="none"/>
    <path d="M132 12 Q 140 4 148 12" stroke={color} strokeOpacity="0.5"/>
    <path d="M132 12 Q 140 20 148 12" stroke={color} strokeOpacity="0.5"/>
  </svg>
);
